import React, { useEffect, useRef } from "react";

import "./style.scss";

interface Props {
  style?: React.CSSProperties;
  children: React.ReactNode;
  className?: string;
  hoverBg: string;
}

const HoverList = (props: Props) => {
  const { style = {}, children, className = "", hoverBg } = props;

  const ref = useRef(null);

  useEffect(() => {});

  return (
    <div className={`hover-list ${className}`} style={style} ref={ref}>
      <div className="hover-block" style={{ background: hoverBg }}></div>
      {children}
    </div>
  );
};

export default HoverList;
